import { defaultAxleRole, type VehicleTyreLayout } from '@chukua/common';
import type { TyreDiagramAxle } from '../../../../reference-data/features/tyre-layouts/public/TyrePositionDiagram';

/** The layout's active positions grouped back into axles, with their roles, for the diagram; a retired position is not on the layout, so not drawn. */
export function toDiagramAxles(layout: Pick<VehicleTyreLayout, 'vehicleKind' | 'slots' | 'axleRoles'>): TyreDiagramAxle[] {
  const byAxle = new Map<number, TyreDiagramAxle>();
  for (const slot of layout.slots.filter((candidate) => !candidate.isRetired)) {
    const axle = byAxle.get(slot.axleNumber) ?? { positions: [] };
    axle.positions.push({ code: slot.positionCode, name: slot.name });
    byAxle.set(slot.axleNumber, axle);
  }
  const subjectKind = layout.vehicleKind === 'truck' ? 'truck_class' : 'trailer_type';
  return [...byAxle.entries()]
    .sort(([a], [b]) => a - b)
    .map(([axleNumber, axle], index) => ({
      ...axle,
      role: layout.axleRoles.find((candidate) => candidate.axleNumber === axleNumber)?.role ?? defaultAxleRole(subjectKind, index),
    }));
}
